import { LexicalComposer as CompLexicalComposer } from '@lexical/react/LexicalComposer';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary.js';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { ContentEditable } from '@lexical/react/LexicalContentEditable.js';
import { memo, useEffect, useRef, useState } from 'react';
import { BlockViewerNode } from './BlockViewerNode';
import formatLexicalInitialValue from './formatLexicalInitialValue';
import { buildCssClassName } from '@shared/utils/buildCssClassName.js';
import { randomId } from '@shared/utils/randomId.js';

// Display only version of lexical inputs. Just renders.

const LexicalDisplay = memo(({ id, value, className, style, variation = 'default' }) => {
  const [initialConfig, setInitialConfig] = useState(null);
  const idRef = useRef(buildCssClassName(id || randomId()));

  useEffect(() => {
    const initialValue = formatLexicalInitialValue(value);
    setInitialConfig({
      namespace: 'LexicalViewer',
      theme: {},
      onError: (error) => console.log(error),
      editorState: initialValue,
      nodes: [BlockViewerNode],
      editable: false
    });
  }, [value]);

  if (!initialConfig) {
    return null;
  }

  return (
    <div className={`lexical-input-wrapper ${idRef.current} ${variation}`}>
      <CompLexicalComposer initialConfig={initialConfig}>
        <RichTextPlugin contentEditable={<ContentEditable className={`lexical-input li-${idRef.current} input-element lexical-display ${className || ''}`} style={style} />} placeholder={null} ErrorBoundary={LexicalErrorBoundary} />
      </CompLexicalComposer>
    </div>
  );
});

LexicalDisplay.displayName = 'LexicalDisplay';

export default LexicalDisplay;
